import { Box, TooltipRenderer, Text } from 'braid-design-system';
interface BarGraphProps {
  items: BarGraphData[];
  maxHeightInPixels?: number;
}
export interface BarGraphData {
  id: string;
  label: string;
  isSelected: boolean;
  value: number;
}

interface BarGraphItemProps {
  id: string;
  label: string;
  isSelected: boolean;
  percentageValue: number;
  width: string;
  margin: string;
}

const BarGraphItem = ({
  id,
  percentageValue,
  label,
  isSelected,
  width,
  margin,
}: BarGraphItemProps) => (
  <TooltipRenderer
    id={`${id}-tooltip`}
    tooltip={<Text>{label}</Text>}
    placement="bottom"
  >
    {({ triggerProps }) => (
      <Box
        display="flex"
        justifyContent="center"
        position="relative"
        alignItems="flexEnd"
        style={{
          height: '100%',
          width,
          margin,
        }}
        {...triggerProps}
      >
        <Box
          position="absolute"
          background={isSelected ? 'neutral' : 'neutralLight'}
          style={{
            height: `${percentageValue}%`,
            width: '100%',
            bottom: 0,
          }}
        />
      </Box>
    )}
  </TooltipRenderer>
);

const percentageValue = (value: number, max: number): number => {
  if (max === 0) {
    return 0;
  }
  return 100 * (value / max);
};

export const BarGraph = ({ items, maxHeightInPixels = 100 }: BarGraphProps) => {
  const maxValue = Math.max(...items.map((item) => item.value));

  return (
    <Box
      flexDirection="row"
      alignItems="flexEnd"
      display="flex"
      justifyContent="center"
      style={{ borderBottom: '1px solid', height: maxHeightInPixels }}
      data-testid="bar-graph"
    >
      {items.map((item) => (
        <BarGraphItem
          key={item.id}
          id={item.id}
          label={item.label}
          isSelected={item.isSelected}
          percentageValue={percentageValue(item.value, maxValue)}
          width={`${100 / items.length / 2}%`}
          margin={`0 ${100 / items.length / 6}%`}
        />
      ))}
    </Box>
  );
};
